<template>
  <el-row>
    <el-form
      ref="form"
      :disabled="isShow"
      :label-width="labelWidth"
      :model="formModel"
      :show-message="false"
      label-position="right"
      size="small"
    >
      <el-row>
        <el-row class="btn-group">
          <slot :name="`header-btn-group-${name}`" />
        </el-row>
        <el-row>
          <el-col :span="totalWidth">
            <div v-for="(formItem, index) in formModel.formList" :key="`formList${index}`" class="row-item">
              <el-col v-if="formItem.show" :span="formItem.split ? formItem.split : split" class="vg_mb_8">
                <el-form-item :label="formItem.label" :prop="`formList.${index}.model`" :rules="formItem.rules" :style="formItemStyle">
                  <div v-if="formItem.itemType === 'uploadImage'" style="display: flex; justify-content: flex-start">
                    <el-image
                      :preview-src-list="[formItem.image_url]"
                      :src="formItem.image_url"
                      class="flexHV"
                      lazy
                      style="height: 80px; width: 80px"
                    >
                      <span slot="error" v-html="'暂无'"></span>
                    </el-image>
                    <el-upload
                      :ref="`uploadMultiple${formItem.prop}`"
                      :action="formItem.uploadUrl ? formItem.uploadUrl : ''"
                      :before-upload="beforeAvatarUpload"
                      :data="{}"
                      :disabled="isShow || formItem.disabled"
                      :on-success="res => handleAvatarSuccess(res, formItem)"
                      :show-file-list="false"
                      class="flexHV"
                    >
                      <el-link :disabled="isShow || formItem.disabled" class="vg_cursor flexHV vg_mr_8" type="primary">{{
                        formItem.model ? '重新上传' : '点击上传'
                      }}</el-link>
                    </el-upload>
                    <div id="preview" class="flexHV">
                      <el-link
                        slot="trigger"
                        :disabled="isShow || formItem.disabled"
                        class="vg_cursor"
                        type="primary"
                        @click="handlePaste(false, formItem.prop)"
                        >粘贴上传</el-link
                      >
                    </div>
                  </div>
                  <el-switch
                    v-if="formItem.itemType === 'switch'"
                    v-model="formItem.model"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change="typeof formItem.change === 'function' ? formItem.change($event) : () => {}"
                  >
                  </el-switch>
                  <div v-if="formItem.itemType === 'input'">
                    <div v-if="computedData && computedData[formItem.prop]" style="display: flex; height: 100%">
                      <el-input
                        :class="formItem.inputAppend ? 'montage' : ''"
                        :value="computedData[formItem.prop]"
                        disabled
                        placeholder="自动计算"
                      />
                      <div v-if="formItem.appendClick" class="appendClass el-input--small">
                        <el-form v-if="formItem.appendDisabled" :disabled="false">
                          <el-link :underline="false" class="vg_cursor" type="primary" @click="formItem.appendClick">
                            {{ formItem.inputAppend }}
                          </el-link>
                        </el-form>
                        <el-link
                          v-else
                          :disabled="isShow"
                          :underline="false"
                          class="vg_cursor"
                          type="primary"
                          @click="formItem.appendClick"
                        >
                          {{ formItem.inputAppend }}
                        </el-link>
                      </div>
                      <div v-else-if="formItem.inputAppend" class="appendClass el-input--small">{{ formItem.inputAppend }}</div>
                    </div>
                    <div v-else style="display: flex; height: 100%">
                      <el-input
                        v-model="formItem.model"
                        :auto-complete="formItem.autoComplete"
                        :autofocus="formItem.autofocus"
                        :autosize="formItem.autosize"
                        :class="formItem.inputAppend ? 'montage' : ''"
                        :disabled="formItem.disabled"
                        :form="formItem.form"
                        :max="formItem.max"
                        :maxlength="formItem.maxlength"
                        :min="formItem.min"
                        :minlength="formItem.minlength"
                        :name="formItem.name"
                        :placeholder="formItem.placeholder ? formItem.placeholder : '请输入'"
                        :readonly="formItem.readonly"
                        :resize="formItem.resize"
                        :rows="formItem.rows"
                        :size="formItem.size"
                        :step="formItem.step"
                        :type="formItem.type"
                        show-word-limit
                        v-bind="$attrs"
                        @blur="typeof formItem.blur === 'function' ? formItem.blur($event) : () => {}"
                        @change="typeof formItem.change === 'function' ? formItem.change($event) : () => {}"
                        @focus="typeof formItem.focus === 'function' ? formItem.focus($event) : () => {}"
                        @input="typeof formItem.input === 'function' ? formItem.input(formModel.formList, index, $event) : () => {}"
                        v-on="$listeners"
                      >
                      </el-input>
                      <div v-if="formItem.appendClick && formItem.inputAppend" class="appendClass el-input--small">
                        <el-form v-if="formItem.appendDisabled" :disabled="false">
                          <el-link :underline="false" class="vg_cursor" type="primary" @click="formItem.appendClick">
                            {{ formItem.inputAppend }}
                          </el-link>
                        </el-form>
                        <el-link
                          v-else-if="formItem.inputAppend"
                          :disabled="isShow"
                          :underline="false"
                          class="vg_cursor"
                          type="primary"
                          @click="formItem.appendClick"
                        >
                          {{ formItem.inputAppend }}
                        </el-link>
                      </div>
                      <div v-else-if="formItem.inputAppend" class="appendClass el-input--small">{{ formItem.inputAppend }}</div>
                    </div>
                  </div>
                  <el-autocomplete
                    v-if="formItem.itemType === 'autocomplete'"
                    v-model.trim="formItem.model"
                    :custom-item="formItem.customItem"
                    :disabled="formItem.disabled"
                    :fetch-suggestions="formItem.fetchSuggestions"
                    :placeholader="formItem.placeholder"
                    :popper-class="formItem.popperClass"
                    :trigger-on-focus="formItem.triggerOnFocus"
                    @select="typeof formItem.select === 'function' ? formItem.select($event) : () => {}"
                  ></el-autocomplete>
                  <el-date-picker
                    v-if="formItem.itemType === 'date'"
                    v-model="formItem.model"
                    :disabled="formItem.disabled"
                    :format="formItem.formatTime"
                    :picker-options="formItem.pickerOptions"
                    :placeholder="formItem.label"
                    :type="formItem.dateType ? formItem.dateType : 'datetime'"
                    value-format="timestamp"
                    @blur="typeof formItem.blur === 'function' ? formItem.blur(formItem.model) : () => {}"
                    @change="typeof formItem.change === 'function' ? formItem.change(formItem.model) : () => {}"
                  ></el-date-picker>
                  <el-date-picker
                    v-if="formItem.itemType === 'dateNoTime'"
                    v-model="formItem.model"
                    :disabled="formItem.disabled"
                    :format="formItem.formatTime"
                    :picker-options="formItem.pickerOptions"
                    :placeholder="formItem.label"
                    type="date"
                    value-format="timestamp"
                    @blur="typeof formItem.blur === 'function' ? formItem.blur(formItem.model) : () => {}"
                    @change="typeof formItem.change === 'function' ? formItem.change(formItem.model) : () => {}"
                  ></el-date-picker>
                  <div v-if="formItem.itemType === 'radio'">
                    <el-radio
                      v-for="(radioItem, index) in formItem.radioOptions"
                      :key="`radio${index}`"
                      v-model="formItem.model"
                      :label="radioItem.label"
                      >{{ radioItem.text }}
                    </el-radio>
                  </div>
                  <el-select
                    v-if="formItem.itemType === 'select'"
                    v-model="formItem.model"
                    :allow-create="formItem.allowCreate"
                    :clearable="formItem.clearable"
                    :disabled="formItem.disabled"
                    :filter-method="formItem.filterMethod"
                    :filterable="formItem.filterable"
                    :loading="formItem.loading"
                    :loading-text="formItem.loadingText"
                    :multiple="formItem.multiple"
                    :multiple-limit="formItem.multipleLimit"
                    :name="formItem.name"
                    :no-data-text="formItem.noDataText"
                    :no-match-text="formItem.noMatchText"
                    :placeholder="'请选择'"
                    :popper-class="formItem.popperClass"
                    :remote="formItem.remote"
                    :size="formItem.size"
                    @change="typeof formItem.change === 'function' ? formItem.change($event) : () => {}"
                  >
                    <el-option
                      v-for="(item, index) in formItem.options"
                      :key="`select${item.value}${index}`"
                      :disabled="item.disabled"
                      :label="item.label"
                      :style="selectOptionStyle"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <span v-else-if="formItem.itemType === 'no'">{{
                    formItem.formatter ? formItem.formatter(formItem.model) : formItem.model
                  }}</span>
                </el-form-item>
              </el-col>
            </div>
          </el-col>
        </el-row>
      </el-row>
    </el-form>
  </el-row>
</template>
<script>
export default {
  name: 'Form',
  data() {
    this.turnData(this.formList);
    return {
      refForm: {},
      formModel: {
        formList: this.formList
      }
    };
  },
  props: {
    dynamicForm: { type: Object, default: () => {} },
    computedData: { type: Object, default: () => {} },
    formList: { type: Array, default: () => [] },
    isShow: { type: Boolean, default: false },
    name: String,
    totalWidth: { type: Number, default: 24 },
    split: { type: Number, default: 8 },
    formItemStyle: String,
    labelWidth: { type: String, default: '130px' },
    selectOptionStyle: String
  },
  watch: {
    formList(val) {
      this.formModel.formList = val;
      this.turnData(this.formModel.formList);
    }
  },
  mounted() {
    this.setAuth();
    this.refForm = this.$refs['form'];
  },
  methods: {
    // 通过一个prop字段设置另一个属性 prop tarPro要设置的目标属性值
    setProperByPro(prop, tarPro) {
      if (typeof tarPro !== 'object') {
        return;
      }
      for (let i = 0; i < this.formList.length; i++) {
        if (this.formList[i].prop === prop) {
          for (let key in tarPro) {
            this.formList[i][key] = tarPro[key];
          }
        }
      }
    },
    // 通过prop 获取表单字段对象
    getPropObjByPro(prop) {
      for (let i = 0; i < this.formList.length; i++) {
        if (this.formList[i].prop === prop) {
          return this.formList[i];
        }
      }
    },
    // 设置权限控制
    setAuth() {
      this.formList.map(item => {
        if (typeof item.dataAuth === 'function') {
          item.dataAuth();
        }
      });
    },
    // 点击确认按钮
    clickSubmit() {
      this.$refs['form'].validate(val => {
        if (val) {
          this.$emit('clickSubmit', this.getFormModel());
        }
      });
    },
    // 获取form model
    getFormModel() {
      let workObj = {};
      for (let i = 0; i < this.$refs['form'].model.formList.length; i++) {
        let obj = this.$refs['form'].model.formList[i];
        workObj[obj.prop] = obj.model;
      }
      return workObj;
    },
    // 获取form model // 必要index字段
    getSpecialFormModel() {
      let formList = this.$refs['form'].model.formList;
      let map = formList.map(({ index }) => index);
      let max = Math.max(...map);
      let arr = [];
      if (max === 0) {
        let workObj = {};
        formList.forEach(item => (workObj[item.prop] = item.itemType === 'date' ? new Date(item.model).getTime() : item.model));
        arr.push(workObj);
      } else {
        for (let i = 0; i <= max; i++) {
          let workObj = {};
          let filter = formList.filter(({ index }) => index === i);
          filter.forEach(item => {
            workObj[item.prop] = item.itemType === 'date' ? new Date(item.model).getTime() : item.model;
          });
          arr.push(workObj);
        }
      }
      return { list: arr };
    },
    // 重置表单
    reset() {
      this.$refs['form'].resetFields();
    },
    // 点击取消按钮
    clickCancel() {
      this.$emit('clickCancel', this.$refs['form']);
    },
    // 当一个表单域从enable 变为disabled时 enabled错误信息不显示
    hiddenMsg() {
      for (let i = 0; i < this.formList.length; i++) {
        if (this.formList[i].disabled) {
          this.formList[i].hiddenMsg = true;
        } else {
          this.formList[i].hiddenMsg = false;
        }
      }
    },
    selectChange(fun, val) {
      if (typeof fun === 'function') {
        fun(val);
      }
      this.setAuth();
      this.hiddenMsg();
    },
    turnData(formList) {
      for (let i = 0; i < formList.length; i++) {
        let item = formList[i];
        if (item.show === undefined) {
          item.show = true;
        }
        if (item.disabled === undefined) {
          item.disabled = false;
        }
      }
    },
    handleAvatarSuccess(res, formItem) {
      if (res.code === 0) {
        this.$set(formItem, 'model', res.data.imge_id);
        this.$set(formItem, 'image_url', res.data.imge_url);
      }
    },
    beforeAvatarUpload(res) {
      const isLt5M = res.size / 1024 / 1024 < 3;
      if (!isLt5M) {
        this.$message.error('图片大小不得超过 3MB!');
        return false;
      }
    },
    handlePaste(event, prop) {
      const pasteImage = ({ ref, index }) => {
        navigator.clipboard
          .read()
          .then(async items => {
            if (items.length === 0 || !items[0].types[0]?.startsWith('image/')) throw new Error('剪贴板中没有图片内容');

            const imageType = items[0].types[0]; // 获取剪贴板中第一个文件的类型

            const blob = await items[0].getType(imageType); // 获取文件的Blob对象

            const file = new File([blob], imageType.replace('/', '.'), { type: imageType }); // 创建File对象

            ref.handleStart(file); // 将图片添加到预上传队列
            ref.submit(); // 提交上传队列
          })
          .catch(error => {
            console.error('粘贴图片失败:', error);
            this.$message.error('粘贴图片失败，请确保剪贴板中有图片内容');
          });
      };
      pasteImage({ ref: this.$refs[`uploadMultiple${prop}`][0], prop });
    }
  }
};
</script>
<style scoped>
.flexHV {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.el-upload-dragger {
  height: 100%;
  width: 100%;
}
/deep/.el-upload {
  height: 100%;
  width: 100%;
}

.upLoad {
  height: 100%;
  width: 100%;
}
.appendClass {
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  border-radius: 0 4px 4px 0;
  border-top: 1px solid #dcdfe6;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-sizing: border-box;
  -webkit-appearance: none;
  height: 32px;
}
::v-deep .el-upload--text {
  width: auto;
  height: auto;
  border: 0;
}
</style>
<style lang="scss" scoped>
.montage {
  ::v-deep.el-input__inner {
    border-radius: 4px 0 0 4px !important;
  }
}
</style>
